// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b770fd16","150":"a29c5230","194":"f3c66f57","216":"5d46bf8c","236":"9e73388d","274":"768c0503","434":"e43d0104","555":"7d848854","677":"bc65c512","773":"6a3c68c3","925":"31bd92c2","986":"96c3dda0"}[chunkId] + ".chunk.js";
};